import React from 'react'

export const FooterSuccess = ({success}) => {
  return (
    <div className='text-success fw-bold'>
      <i class="fa fa-check" aria-hidden="true"></i>
      <span className="ms-2">{success}</span>
    </div>
  )
}